// extracted by mini-css-extract-plugin
module.exports = {"StrollerDetailRating":"xg_a bhc_a bhc_x","StrollerDetailRating__muted":"xg_b bhc_fi"};